import { authConfig } from "../apiConfig";



export const get_equipment_with_out_pagination = async () => {
    try {
        const response = await authConfig.post(`getEquipmentslist`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_equipment_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`getEquipmentslist`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};
export const get_equipment_by_id = async (data) => {
    try {
        const response = await authConfig.post(`viewEquipmentById`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const equipment_creation = async (data) => {
    try {
        const response = await authConfig.post(`createEquipments`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const equipment_update = async (data) => {
    try {
        const response = await authConfig.post(`updateEquipments`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const equipment_deletion = async (data) => {
    try {
        const response = await authConfig.post(`equipmentDelete`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response;
    } catch (error) {
        throw error;
    }
};

export const get_available_equipment_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`listAvailableEquipments`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const get_available_equipment_without_pagination = async () => {
    try {
        const response = await authConfig.post(`listAvailableEquipments`, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};